module.exports = __webpack_public_path__ + "static/media/Settings_Divider@3x.a97b550c.png";